import Text from './Text'
import Heading from '../Heading'
import RichText from '../RichText'

Text.Title = Heading
Text.Body = RichText

export default Text
